<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="registervideoContainer"></div>
      <div class="w">
        <div class="download-section">
          <div class="download-item">
            <h3>下载 Android App</h3>
            <button @click="downloadApk" class="download-button">
              <svg t="1749221866392" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3648" width="25" height="20">
                <path d="M0 512c0-159.061333 0-238.549333 25.984-301.269333a341.333333 341.333333 0 0 1 184.746667-184.746667C273.450667 0 352.938667 0 512 0c159.018667 0 238.549333 0 301.269333 25.984a341.333333 341.333333 0 0 1 184.746667 184.746667C1024 273.450667 1024 352.938667 1024 512c0 159.018667 0 238.549333-25.984 301.269333a341.333333 341.333333 0 0 1-184.746667 184.746667C750.549333 1024 671.018667 1024 512 1024c-159.061333 0-238.549333 0-301.269333-25.984a341.333333 341.333333 0 0 1-184.746667-184.746667C0 750.549333 0 671.018667 0 512z" fill="#1296db" p-id="3649" data-spm-anchor-id="a313x.search_index.0.i3.73433a81m7EeGM" class="selected"></path><path d="M716.501333 304.64c-19.157333-10.88-34.261333-6.912-45.312 11.946667l-33.194666 56.618666-0.682667 1.237334a295.253333 295.253333 0 0 0-125.354667-29.226667 293.12 293.12 0 0 0-116.736 25.301333l-31.573333-53.930666c-11.093333-18.858667-26.197333-22.826667-45.354667-11.946667-19.157333 10.88-23.210667 25.770667-12.16 44.629333l31.573334 53.845334c-72.064 51.2-124.245333 132.821333-124.245334 230.613333l-0.042666 1.450667a33.92 33.92 0 0 0 9.301333 25.856 34.986667 34.986667 0 0 0 25.557333 10.965333H775.68a35.413333 35.413333 0 0 0 25.429333-10.794667 34.261333 34.261333 0 0 0 9.386667-26.88c0-94.72-48.597333-174.208-116.778667-225.706666 0.597333-0.853333 1.152-1.792 1.706667-2.730667l33.194667-56.618667c11.093333-18.858667 6.997333-33.706667-12.16-44.629333z" fill="#FFFFFF" p-id="3650"></path><path d="M379.306667 573.952a32.426667 32.426667 0 0 0 9.685333 23.125333 33.450667 33.450667 0 0 0 46.933333 0 32.426667 32.426667 0 0 0-10.752-53.333333 33.621333 33.621333 0 0 0-36.181333 7.125333 32.64 32.64 0 0 0-9.728 23.082667zM578.389333 573.952a32.426667 32.426667 0 0 0 9.728 23.125333 33.450667 33.450667 0 0 0 46.933334 0 32.426667 32.426667 0 0 0 0-46.208 33.450667 33.450667 0 0 0-46.933334 0 32.426667 32.426667 0 0 0-9.728 23.082667z" fill="#27AD9A" p-id="3651"></path>
              <a href="https://b.410121.xyz/app.apk" target="_blank" rel="noopener noreferrer"></a>
              </svg>
            </button>
          </div>
          <div class="download-item">
            <h3>下载 Windows exe</h3>
            <button @click="downloadExe" class="download-button">
              <svg t="1749221958872" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5570" width="25" height="20">
                <path d="M456 484V160.1l-335.9 72V484H456zM512 484h391.8V64.2l-391.8 84V484zM456 540H120.2v251.9l335.9 72V540zM512 540v335.9l391.8 84V540H512z" fill="#00adef" p-id="5571"></path>
                <a href="https://e.410121.xyz/tixingben.exe" target="_blank" rel="noopener noreferrer"></a>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: null,
      VersionFlag: false,
    };
  },
  mounted() {
    this.checkVersion();
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!token || !isLoggedIn) {
      this.$message.error('请先登录');
      this.$router.push('/login');
      return;
    }
  },
  methods: {
    downloadApk() {
      this.loading = true;
      this.error = null;
      const url = 'https://b.410121.xyz/app.apk'; // 替换为实际APK下载地址
      this.downloadFile(url, 'app.apk');
    },
    downloadExe() {
      this.loading = true;
      this.error = null;
      const url = 'https://e.410121.xyz/tixingben.exe'; // 替换为实际EXE下载地址
      this.downloadFile(url, 'tixingben.exe');
    },
    downloadFile(url, filename) {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
      this.$message.success(`下载 ${filename} 开始`);
    },
    upgrade() {
      this.closeVersionCover();
    },
    closeVersionCover() {
      this.VersionFlag = false;
    }
  }
};
</script>

<style scoped>
.w {
  width: 1700px;
  margin: 0 auto;
}
img {
  width: 100%;
  height: 100%;
  display: block;
}
#home {
  width: 100%;
}
#contentBox {
  width: 100%;
  height: 100%;
  position: relative;
  background-repeat: no-repeat;
  overflow: auto;
  z-index: 0;
}
.registervideoContainer {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 0rem;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url(../assets/2.jpg);
  filter: blur(6px);
}
.download-section {
  display: flex;
  justify-content: center;
  gap: 50px;
  padding: 50px 0;
}
.download-item {
  text-align: center;
}
.download-item h3 {
  font-size: 24px;
  color: #054e61b4;
  margin-bottom: 10px;
}
.download-button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 9px;
  background-color: #4bd5db;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.3s;
}
.download-button:hover {
  background-color: #00a7b38c;
}
.loading, .error {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
}
.Version_cover {
  width: 100%;
  height: 100vh;
  background: #000000b3;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}
.Version_cover .center_box {
  width: 15%;
  height: 15rem;
  border-radius: 0.533333rem;
  background: #7bbfd4af;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Version_cover .center_box h3 {
  width: 100%;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  padding: 0.266666rem;
}
.Version_cover .center_box .explain {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.2rem;
  opacity: 0.9;
}
.Version_cover .center_box .btn {
  width: 80%;
  height: 3rem;
  background: #ff4400b6;
  border-radius: 0.533333rem;
  font-size: 2rem;
  color: #ffffff;
  line-height: 3.066666rem;
  text-align: center;
  letter-spacing: 1px;
  position: absolute;
  bottom: 0.266666rem;
  left: 50%;
  transform: translateX(-50%);
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 33px;
  color: #000000;
}
@media screen and (max-width: 1600px) {
  .w {
    max-width: 1400px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1400px) {
  .w {
    max-width: 1200px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1200px) {
  .w {
    max-width: 1000px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1000px) {
  .w {
    max-width: 100%;
  }
  .Version_cover .center_box {
    width: 65%;
    height: 15rem;
    border-radius: 0.533333rem;
    background: rgba(123, 191, 212, 0.685);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 550px) {
  .w {
    max-width: 100%;
  }
  .Version_cover .center_box {
    width: 65%;
    height: 15rem;
    border-radius: 0.533333rem;
    background: rgba(123, 191, 212, 0.685);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>